import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { DocumentActionService } from 'src/app/core/services/document-action-service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-upload-candidate-document',
  templateUrl: './upload-candidate-document.component.html'
})
export class UploadCandidateDocumentComponent implements OnInit {
  @Input() document: any;
  @Input() showUpload: boolean = false;
  @Input() share: boolean;
  @Input() candidateType: any;
  @Input() candidateDetails: any;
  @Input() allFolders: any[] = [];
  @Input() isSharedDocumentActionAvailable = false;
  @Input() companiesToShareCandidateDocuments: any[] = [];
  @Input() sourceScreen = '';
  @Input() formalizeActivityPayload: any;

  @Output() cancelCallback = new EventEmitter<any>();
  @Output() saveCallback = new EventEmitter<any>();

  @ViewChild(DropzoneDirective) fileUploadDropZone: DropzoneDirective;

  userId: any;
  isEdit = false;
  hideShare = false;
  showUploadWizard = false;
  uploadClicked = false;
  savingFlag = false;
  documentList: any[] = [];
  companiesToShare: any[] = [];
  selectedCompaniesToShare: any[] = [];
  uploadResumesResponse: any = null;
  disableUploadButtonFlag = true;
  fileExistsFlag = false;
  fileUploadInProgressFlag = false;
  dropzoneConfig: DropzoneConfigInterface;
  private originalSharedEntityIds: any;

  constructor(
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private documentService: DocumentService,
    private documentActionService: DocumentActionService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.userId = this.authService.getUserDetails().id;
    this.isEdit = this.document.id ? true : false;
    if (this.share === undefined) {
      this.share = false;
    } else {
      this.document.shared = true;
    }
    this.hideShare = (!this.share && !this.showUpload) || (this.showUpload && !this.isSharedDocumentActionAvailable);
    this.showUploadWizard = !this.isEdit;
    this.uploadClicked = false;
    this.initVariables();
    this.getCompaniesToShareCandidateDocuments();

    this.documentList = [];
    this.dropzoneConfig = this._getDropZoneSettings();
    this.originalSharedEntityIds = this.document ? _.cloneDeep(this.document.sharedEntityIds) : '';
  }

  initVariables() {
    this.documentList = [];
    this.companiesToShare = [];
    this.selectedCompaniesToShare = [];
    this.uploadResumesResponse = null;
    this.disableUploadButtonFlag = true;
    this.fileExistsFlag = false;
    this.fileUploadInProgressFlag = false;
  }

  getCompaniesToShareCandidateDocuments() {
    this.companiesToShare = this.companiesToShareCandidateDocuments ? [...this.companiesToShareCandidateDocuments] : [];
    this.companiesToShare.map(company => company.selected = false);
    if (this.companiesToShare) {
      this.companiesToShare.forEach(company => {
        if (this.document.sharedEntityIds.includes(company.id)) {
          company.selected = true;
          this.selectedCompaniesToShare.push(company);
        }
      });
    }
  }

  onFileAdded() {
    this.fileExistsFlag = true;
    this.disableUploadButtonFlag = false;
    $('.dz-progress').css({ top: '70%' });
  }

  onFileRemoved() {
    this.fileExistsFlag = false;
    this.disableUploadButtonFlag = true;
    this.fileUploadInProgressFlag = false;
  }

  onFileSendingMultiple(args) {
    const formData = args[2];
    this.disableUploadButtonFlag = true;
    this.fileUploadInProgressFlag = true;
    const sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(',') : null;
    if (this.document.id) {
      formData.append('documentId', this.document.id);
    }
    formData.append('companyId', this.document.companyId);
    formData.append('candidateId', this.document.candidateId);
    formData.append('internalNote', this.document.internalNote);
    formData.append('sharedEntityIds', sharedEntityIds);
    formData.append('shareDocument', this.document.shared);
    formData.append('folderId', this.document.folderId);
    formData.append('candidateType', this.candidateType);
    formData.append('userId', this.userId);
    if (this.candidateDetails.jobMatchId) {
      formData.append('jobMatchId', this.candidateDetails.jobMatchId);
    }
  }

  onFileSuccessMultiple(args) {
    const response = args[1];
    this.fileUploadInProgressFlag = false;
    this.disableUploadButtonFlag = true;
    this.uploadResumesResponse = response;

    if (response.files !== undefined && response.files.length > 0) {
      this.documentList = [...response.files];
    }
    $('.dz-hidden-input').prop('disabled', true);
    this.alertsAndNotificationsService.showBannerMessage('Document(s) uploaded successfully.', 'success');
    if (this.saveCallback) {
      this.saveCallback.emit();
    }
  }

  onFileError(args) {
    const file = args[0];
    const error = args[1];
    this.fileUploadInProgressFlag = false;
    const elements = document.querySelectorAll('.dz-file-preview');
    elements.forEach((element: any) => {
      const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
      const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
      if (filename === file.name) {
        errorMessage.textContent = error.message === undefined ? error : error.message;
      }
    });
  }

  private _getDropZoneSettings(): DropzoneConfigInterface {
    const maxFilesToUpload = 100;
    let dropZoneSettings = {};
    dropZoneSettings = {
      url: this.documentService.getUploadUrl(),
      paramName: () => 'files',
      acceptedFiles: '.pdf,.xlsx,.docx,.doc',
      maxFiles: maxFilesToUpload,
      maxFilesize: 10,
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: true,
      parallelUploads: 100
    };
    return dropZoneSettings;
  }

  onCompanyToShareSelected() {
    if (this.selectedCompaniesToShare && this.selectedCompaniesToShare.length > 0) {
      const sharedEntityIds: any[] = [];
      this.selectedCompaniesToShare.forEach(company => {
        sharedEntityIds.push(company.id);
      });
      this.document.sharedEntityIds = sharedEntityIds.toString();
    }
  }

  updateDocumentData() {
    if (this._isDataValid()) {
      this.document.shareDocument = this.document.shared;
      this.document.documentId = this.document.id;
      if (this.originalSharedEntityIds && this.originalSharedEntityIds.length > 0) {
        const unSharedEntityIds: any[] = [];
        this.originalSharedEntityIds.map(company => {
          if (!this.document.sharedEntityIds.includes(company)) {
            unSharedEntityIds.push(company);
          }
        });
        this.document.unSharedEntityIds = unSharedEntityIds.toString();
      }
      this.document.sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(',') : null;
      this.document.candidateType = this.candidateType;
      this.document.userId = this.userId;
      this.documentActionService.setParentAndChildFolderName(this.allFolders, this.document);
      if (this.candidateDetails.jobMatchId) {
        this.document.jobMatchId = this.candidateDetails.jobMatchId;
      }

      this.documentService.updateCandidateDocumentData(this.document, (data) => {
        const message = this.share ? 'Document shared successfully.' : 'Document updated successfully.';
        this.alertsAndNotificationsService.showBannerMessage(message, 'success');
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
      }, error => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  uploadDocument() {
    this.uploadClicked = true;
    if (this._isDataValid()) {
      this.fileUploadDropZone.dropzone().processQueue();
    }
  }

  private _isDataValid() {
    this.document.sharedEntityIds = this.selectedCompaniesToShare.map(company => company.id);
    return !this.document.shared || (this.document.shared && this.document.sharedEntityIds.length >= 0);
  }

  removeAllSelectedCompanies() {
    this.companiesToShare.forEach(company => {
      company.selected = false;
    });
    this.selectedCompaniesToShare = [];
    this.document.sharedEntityIds = '';
  }

  selectAllCompaniesToShare() {
    this.selectedCompaniesToShare = [...this.companiesToShare];
    this.companiesToShare.forEach(company => company.selected = true);
    this.onCompanyToShareSelected();
  }

  receiveFormalizedComment(event: string) {
    this.document.internalNote = event;
  }

  onVoiceTranscript(transcript: string) {
    if (this.document.internalNote) {
      this.document.internalNote += ' ' + transcript;
    } else {
      this.document.internalNote = transcript;
    }
  }
}
